import { Injectable, NgZone } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlatformService } from '@core/services/platform.service';
import { finalize } from 'rxjs/operators';
import { SiteStateService } from '@core/services/site-state/site-state.service';

@Injectable()
export class ProgressInterceptor implements HttpInterceptor {
    private timer: number;
    private count = 0;
    private msBeforeProgressShown = 350;

    constructor(
        private platformService: PlatformService,
        private siteStateService: SiteStateService,
        private readonly ngZone: NgZone
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (this.platformService.isServer) {
            return next.handle(request);
        }

        if (this.count === 0) {
            this.ngZone.runOutsideAngular(() => {
                this.timer = window.setTimeout(() => {
                    this.ngZone.run(() => {
                        this.siteStateService.setState('progress', true);
                    });
                }, this.msBeforeProgressShown);
            });
        }

        this.count++;
        return next.handle(request).pipe(
            finalize(() => {
                this.count--;
                if (this.count === 0) {
                    clearTimeout(this.timer);
                    this.siteStateService.setState('progress', false);
                }
            })
        );
    }
}
